import React from 'react';
import { Typography } from '@mui/material';
import { StyledCountBoxIcon } from './tab.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export var CounterIcon = function CounterIcon(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? 'start' : _ref$iconPosition;
  return /*#__PURE__*/_jsx(StyledCountBoxIcon, {
    iconPosition: iconPosition,
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "caption2",
      fontWeight: "bold",
      children: count
    })
  });
};